<template>
    <div class="secondary">
        <v-row no-gutters class="py-8 px-sm-6">
            <v-col cols="5" sm="4" class="pl-4">
                <div class="white--text font-weight-bold caption">MENÚ</div>
                <div><a class="white--text linky caption font-weight-medium" @click="goSectionHome('inicio')">Inicio</a></div>
                <div><a class="white--text linky caption font-weight-medium"  @click="goSectionHome('nosotros')">Nosotros</a></div>
                <div><a class="white--text linky caption font-weight-medium" @click="$router.push('/servicios')">Servicios</a></div>
                <div><a class="white--text linky caption font-weight-medium" @click="goSectionHome('clientes')">Clientes</a></div>
                <div><a class="white--text linky caption font-weight-medium" @click="goSectionHome('contacto')">Contacto</a></div>
                <div class="mt-6 d-flex">
                    <div>
                        <v-img 
                            :src="require(`@/assets/maya/_/ic-instagram.png`)" 
                            max-width="28px" alt="Instagram" contain
                            @click="goInstagram"
                            style="cursor:pointer"></v-img>
                    </div>
                    <div class="px-1">
                        <v-img 
                            :src="require(`@/assets/maya/_/ic-linkedin.png`)" 
                            max-width="28px" alt="Linkedin" contain
                            @click="goLinkedin"
                            style="cursor:pointer"></v-img>
                    </div>
                    <div>
                        <v-img 
                            :src="require(`@/assets/maya/_/ic-facebook.png`)" 
                            max-width="28px" alt="Facebook" contain
                            @click="goFacebook"
                            style="cursor:pointer"></v-img>
                    </div>
                </div>
            </v-col>

            <v-col sm="4" v-if="$vuetify.breakpoint.smAndUp">
                <div class="white--text font-weight-bold caption">SERVICIOS</div>
                <div><a class="white--text linky caption" @click="$router.push('/servicios/gp12')">Servicios GP12</a></div>
                <div><a class="white--text linky caption" @click="$router.push('/servicios/incoming-inspection')">Incoming Inspection</a></div>
                <div><a class="white--text linky caption" @click="$router.push('/servicios/cs1-cs2')">CS1 y CS2</a></div>
                <div><a class="white--text linky caption" @click="$router.push('/servicios/retrabajo')">Retrabajo</a></div>
                <div><a class="white--text linky caption" @click="$router.push('/servicios/sorteos')">Sorteos</a></div>
                <div><a class="white--text linky caption" @click="$router.push('/servicios/ensambles')">Ensambles</a></div>
            </v-col>

            <!-- <v-col sm="3" v-if="$vuetify.breakpoint.smAndUp">
                <div class="white--text font-weight-bold caption">INDUSTRIAS</div>
                <div><a class="white--text linky caption" @click="$router.push('/')">Automotriz</a></div>
                <div><a class="white--text linky caption" @click="$router.push('/')">Farmacéutica</a></div>
            </v-col> -->

            <v-col cols="7" sm="4">
                <div class="white--text font-weight-bold caption">LEGAL</div>
                <div><a class="white--text linky caption" href="https://firebasestorage.googleapis.com/v0/b/msorting-193e2.appspot.com/o/BROCHURE_RH-09-1.jpeg?alt=media&token=42b073ea-2cc7-4e18-8536-03063722d782" target="_blank" style="text-decoration:none">Forma parte del equipo MSO</a></div>
                <div><a class="white--text linky caption" @click="$router.push('/aviso-de-privacidad')">Aviso de privacidad</a></div>
                <!-- <div><a class="white--text linky caption" @click="$router.push('/')">Términos de uso</a></div> -->
            </v-col>
        </v-row>

        <div class="text-center white--text caption primary py-4 px-4">
            <div>
                ® MSo Soluciones en Inspección S.A. de C.V.
            </div>
            <!-- <div>
                Para mayor información consulte nuestros Términos de uso.
            </div> -->
            <div>
                Diseño y desarrollo creativo por <span class="font-weight-bold">Brandology Bar. ®</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goSectionHome(section) {
            this.$store.dispatch('setActual', section);
            this.$router.push('/');
        },
        goInstagram(){
            window.open('https://instagram.com/msorting');
        },
        goFacebook(){
            window.open('https://www.facebook.com/MSO-654122908553918');
        },
        goLinkedin(){
            
        }
    }
}
</script>

<style scoped>
    .linky:hover {
        text-decoration: underline;
    }
</style>